import { render, staticRenderFns } from "./bgys-asset-group-category-asset-group-criticality-view.vue?vue&type=template&id=97e16826&scoped=true"
import script from "./bgys-asset-group-category-asset-group-criticality-view.vue?vue&type=script&lang=js"
export * from "./bgys-asset-group-category-asset-group-criticality-view.vue?vue&type=script&lang=js"
import style0 from "./bgys-asset-group-category-asset-group-criticality-view.vue?vue&type=style&index=0&id=97e16826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e16826",
  null
  
)

export default component.exports